import { createStore } from 'vuex'
import axios from 'axios'
import qs from 'qs'

export default createStore({
  state: {
    loaded: false,
    entries: [],
    categories: [],
    currentPage: 1,
    itemsPerPage: 13, // 13
    numberOfPages: 1,
    numberOfTotalArticles: 0,
    entriesFilter: window.app.blog_list.categoryUid
  },
  getters: {
    getParams: (state) => {
      const params = {
        currentPage: state.currentPage,
        itemsPerPage: state.itemsPerPage
      }
      if (state.entriesFilter > 0) {
        params.category = {
          equals: state.entriesFilter
        }
      }
      return params
    }
  },
  mutations: {
    setLoaded (state, payload) {
      state.loaded = payload
    },
    setEntries (state, payload) {
      state.entries = payload
    },
    addEntries (state, payload) {
      state.entries = [...state.entries, ...payload]
    },
    setCategories (state, payload) {
      state.categories = payload
    },
    resetCurrentPage (state) {
      state.currentPage = 1
    },
    increaseCurrentPage (state) {
      state.currentPage += 1
    },
    setNumberOfPages (state, payload) {
      state.numberOfPages = payload
    },
    setNumberOfTotalItems (state, payload) {
      state.numberOfTotalArticles = payload
    }
  },
  actions: {
    async getEntries ({ commit, getters, state }) {
      commit('setLoaded', false)
      try {
        const response = await axios.get(window.app.blog_list.api_base + 'blog-entries' + '/?' + qs.stringify(getters.getParams))
        state.currentPage === 1
          ? commit('setEntries', response.data.blogentries)
          : commit('addEntries', response.data.blogentries)
        commit('setNumberOfPages', response.data.numberOfPages)
        commit('setNumberOfTotalItems', response.data.numberOfTotalItems)
        commit('setLoaded', true)
        return response
      } catch (e) {
        commit('setErrors', e, { root: true })
      }
    },
    async getCategories ({ commit }) {
      commit('setLoaded', false)
      try {
        const response = await axios.get(window.app.blog_list.api_base + 'blog-categories' + '/')
        commit('setCategories', response.data)
        commit('setLoaded', true)
        return response
      } catch (e) {
        commit('setErrors', e, { root: true })
      }
    },
    async increasePage ({ commit }) {
      commit('increaseCurrentPage')
    }
  },
  modules: {}
})
